<template>
  <div class="spinner">
    <div class="dot one" />
    <div class="dot two" />
    <div class="dot three" />
    <div class="dot four" />
  </div>
</template>

<script>

export default {
  name: 'Spinner',
}

</script>
